import { ChangeHighlightedCheckboxFormFieldRow } from '@rd-web-markets/shared/dist/util/form/ChangeHighlightedCheckboxFormFieldRow';
import { ChangeHighlightedFormDropdownRow } from '@rd-web-markets/shared/dist/util/form/ChangeHighlightedFormDropdownRow';
import { ChangeHighlightedInputFormFieldRow } from '@rd-web-markets/shared/dist/util/form/ChangeHighlightedInputFormFieldRow';
import React from 'react';
import { useTranslation } from 'react-i18next';
export default function RndTrialsRelatedFields(_ref) {
  let {
    report,
    handleChange,
    handleSubmit,
    labelColSpan = 4,
    valueColSpan = 4,
    disabled = false
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChangeHighlightedCheckboxFormFieldRow, {
    labelColSpan: labelColSpan,
    valueColSpan: valueColSpan,
    fieldName: "are_rnd_trials_undertaken",
    object: report,
    onChange: handleChange,
    onBlur: handleSubmit,
    disabled: disabled
  }), report.are_rnd_trials_undertaken && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChangeHighlightedFormDropdownRow, {
    labelColSpan: labelColSpan,
    valueColSpan: valueColSpan,
    fieldName: "run_data_type",
    valuesArray: [{
      id: 0,
      value: 'hours',
      name: t('hours')
    }, {
      id: 1,
      value: 'days',
      name: t('days')
    }],
    object: report,
    onChange: event => handleChange(event),
    onBlur: handleSubmit,
    disabled: disabled
  }), /*#__PURE__*/React.createElement(ChangeHighlightedInputFormFieldRow, {
    type: "number",
    labelColSpan: labelColSpan,
    valueColSpan: valueColSpan,
    fieldName: "total_run_duration",
    object: report,
    onChange: handleChange,
    onBlur: handleSubmit,
    disabled: disabled
  }), /*#__PURE__*/React.createElement(ChangeHighlightedInputFormFieldRow, {
    type: "number",
    labelColSpan: labelColSpan,
    valueColSpan: valueColSpan,
    fieldName: "total_rnd_trial_duration",
    object: report,
    onChange: handleChange,
    onBlur: handleSubmit,
    disabled: disabled
  }), /*#__PURE__*/React.createElement(ChangeHighlightedInputFormFieldRow, {
    type: "number",
    labelColSpan: labelColSpan,
    valueColSpan: valueColSpan,
    fieldName: "factory_staff_fte",
    object: report,
    onChange: handleChange,
    onBlur: handleSubmit,
    disabled: disabled
  }), /*#__PURE__*/React.createElement(ChangeHighlightedInputFormFieldRow, {
    type: "number",
    labelColSpan: labelColSpan,
    valueColSpan: valueColSpan,
    fieldName: "waste_ratio",
    object: report,
    onChange: handleChange,
    onBlur: handleSubmit,
    disabled: disabled
  })));
}